export enum PrinterMechanismStatusEnum {
    NoError = 0,
    OpenCover = 1,
    NoAccess = 2,
    CoverUp = 3,
    NoPaper = 5,
    WrongTemperatureOrPower = 6,
    TemporaryPowerFailure = 7,
    CutterError = 8,
    PowerFailure = 9,
    CoverUpWhileCuttting = 10,
}